import store from "@/store";

const hasPermissionConselho = (conselho = null) => {
  const roles = store.getters["auth/GetUserRoles"];
  const user_id = store.getters["auth/GetUser"].id;

  let has_permission =
    roles.findIndex((v) => v == "super-admin") >= 0 ||
    roles.findIndex((v) => v == "admin") >= 0;

  if (!has_permission && conselho) {
    has_permission =
      conselho.usuarios.findIndex((user) => user.id == user_id) >= 0;
  }

  return has_permission;
};

const hasPermission = (permissionName) => {
  return store.getters["acl/GetCan"](permissionName);
};

export { hasPermission, hasPermissionConselho };
export default hasPermission;
